import { LocalizationContext } from 'contexts/LocalizationContext';
import { useContext } from 'react';

export default function useLocalization() {
  return useContext(LocalizationContext);
}
